import { Box, Typography, Button, Divider } from "@mui/material";
import { PrescriptionResponseDtoStatusEnum } from "libs/cellera-sdk";
import React from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";

import { StatusTag } from "./StatusTag";

interface FeesAndTotalSummaryProps {
  formulaTotal: number;
  status: PrescriptionResponseDtoStatusEnum;
  onViewInvoice?: () => void;
}

export const FeesAndTotalSummary: React.FC<FeesAndTotalSummaryProps> = ({
  formulaTotal,
  status,
  onViewInvoice,
}) => {
  const { colors } = useCelleraTheme();

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price);
  };

  return (
    <Box
      sx={{
        border: `1px solid ${colors.border.light}`,
        borderRadius: "8px",
        p: "16px",
        backgroundColor: colors.background.paper,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: colors.text.primary,
          mb: 3,
        }}
      >
        Fees & Total Summary
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: colors.text.secondary, mb: 1 }}
        >
          Payment Status:
        </Typography>
        <StatusTag status={status} />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: colors.text.secondary }}>
            Subtotal (Supplement):
          </Typography>
          <Typography variant="body2" sx={{ color: colors.text.primary }}>
            {formatPrice(formulaTotal)}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.text.primary,
              fontWeight: 600,
              fontSize: "18px",
            }}
          >
            Total:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: colors.text.primary,
              fontWeight: 600,
              fontSize: "18px",
            }}
          >
            {formatPrice(formulaTotal)}
          </Typography>
        </Box>
      </Box>

      {onViewInvoice && (
        <Box>
          <Divider />
          <Button
            className="py-0 px-3 rounded-full"
            sx={{
              mt: 2,
              backgroundColor: colors.background.paper,
              color: colors.text.primary,
              border: `1px solid ${colors.border.main}`,
            }}
            onClick={onViewInvoice}
          >
            View Invoice
          </Button>
        </Box>
      )}
    </Box>
  );
};
